import { Button, Flex } from 'zui/Antd';

const InventoryTTLockActions = ({
	record,
	selectedInventoryUIDs,
	setSelectedInventoryUIDs,
	setSelectedDevice,
	setVisibleEditLocation,
	setOpenAssignModal,
	setOpenUnassignModal
}) => {
	const handleAssign = (e) => {
		e.stopPropagation();

		setSelectedInventoryUIDs((prev) => {
			const exists = prev.some((item) => item.inventoryUID === record.inventoryUID);
			if (exists) return prev;

			return [
				...prev,
				{
					inventoryUID: record.inventoryUID,
					deviceID: null,
					orgID: null,
					name: record.inventoryName
				}
			];
		});

		setOpenAssignModal(true);
	};

	const handleModifyLocation = (e) => {
		e.stopPropagation();

		setSelectedDevice({
			deviceID: record.assetID,
			name: record.inventoryName,
			orgID: record.orgOrgID,
			orgName: record.orgName
		});

		setVisibleEditLocation(true);
	};

	const handleUnassign = (e) => {
		e.stopPropagation();

		if (selectedInventoryUIDs.length === 0) {
			setSelectedInventoryUIDs([
				{
					inventoryUID: record.inventoryUID,
					deviceID: record.assetID,
					orgID: record.orgOrgID,
					name: record.inventoryName
				}
			]);
		}

		setOpenUnassignModal(true);
	};

	if (!record.orgOrgID) {
		return (
			<Button size='small' type='primary' onClick={handleAssign}>
				Assign
			</Button>
		);
	}

	return (
		<Flex gap={8} justify='space-between'>
			<Button size='small' type='primary' onClick={handleModifyLocation}>
				Modify Location
			</Button>
			<Button size='small' type='primary' onClick={handleUnassign}>
				Unassign
			</Button>
		</Flex>
	);
};

export default InventoryTTLockActions;
